module.exports = __webpack_public_path__ + "am.svg?7f0889c024d50d1d7830eb0a9f59aa09";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/am.svg
// module id = 933
// module chunks = 27